export default "__VITE_ASSET__0cd9a8c7__"